import React from "react";
import { Link } from "react-router-dom";
import { Button, Container, Typography, Box, AppBar, Toolbar, Paper } from "@mui/material";
import BackToCPQButton from "../../Components/backToCPQButton";
import Dynamics365NavigationBar from "../Dynamics365QuoteProductPages/Dynamics365NavigationBar";
import PreviousPageButtonCPQ from "../../Components/PreviousPageButtonCPQ";
const CPQSettingPage = () => {
    const forms = [
        { path: "/EcoProtector-setting", label: "EcoProtector Setting" },
        { path: "/pumpstation-setting", label: "Pump Station Setting" },
        { path: "/pumpstation-freight-setting", label: "Freight Setting" },
    ];

    return (
        <Box sx={{ p: 3, pt: 0 }}>
            {/* <NavigationBar /> */}
            <Dynamics365NavigationBar />

            <Paper elevation={3} sx={{ p: 2, width: "60%", margin: "auto" }}>
                <Typography variant="h5" align="center">
                    Select a product setting:
                </Typography>
                <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={2}
                    padding={3}
                    paddingX={5}
                >
                    {forms.map((form) => (
                        <Button
                            key={form.path}
                            variant="contained"
                            color={form.path === "/pumpstation-freight-setting" ? "secondary" : "primary"}
                            component={Link}
                            to={form.path}
                            fullWidth
                        >
                            {form.label}
                        </Button>
                    ))}
                </Box>
            </Paper>

            <Box sx={{ display: "flex", justifyContent: "center", gap: 2 }}>
                <BackToCPQButton />
                <PreviousPageButtonCPQ />
            </Box>
        </Box>
    );
};

export default CPQSettingPage;
